import { ThemeProvider } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AwsRum } from 'aws-rum-web';
import { Config as MixpanelConfig } from 'mixpanel-browser';
import { MixpanelProvider } from 'react-mixpanel-browser';
import { RouterProvider } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';

import { queryClient } from '@/common/react-query';
import { FeatureFlagsProvider } from '@/components/providers/FeatureFlagProvider';
import { AwsRumEnvironments, getAwsRumConfig } from '@/config';
import { MapUiContextProvider } from '@/context/MapUiContext';
import theme from '@/theme';

import { router } from './routes';

// [OPTIONAL] Custom options to pass to `mixpanel.init()`.
const MIXPANEL_CONFIG: Partial<MixpanelConfig> = {
    track_pageview: false, // we handle our own page tracking in RootLayout
    debug: false, // Set to `false` by default
};

export let awsRum: AwsRum;
try {
    const { appConfig, awsRumConfig } = getAwsRumConfig(
        process.env.REACT_APP_AWS_RUM_ENVIRONMENT as AwsRumEnvironments
    );
    awsRum = new AwsRum(appConfig.id, appConfig.version, appConfig.region, awsRumConfig);
} catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    // eslint-disable-next-line no-console
    console.log(error);
}

export default function Root() {
    return (
        <MixpanelProvider config={MIXPANEL_CONFIG} token={process.env.REACT_APP_MIXPANEL_TOKEN}>
            <QueryParamProvider>
                <QueryClientProvider client={queryClient}>
                    <FeatureFlagsProvider>
                        <ReactQueryDevtools initialIsOpen={false} />
                        <MapUiContextProvider>
                            <ThemeProvider theme={theme}>
                                <RouterProvider router={router()} />
                            </ThemeProvider>
                        </MapUiContextProvider>
                    </FeatureFlagsProvider>
                </QueryClientProvider>
            </QueryParamProvider>
        </MixpanelProvider>
    );
}
